// src/pages/SuperAdminDashboardPage.jsx
import React from 'react';
import Layout from '../components/Layout';
import SuperAdminDashboard from '../components/SuperAdminDashboard';

const SuperAdminDashboardPage = () => {
  const role = 'superadmin';
  return (
    <Layout role={role}>
      <SuperAdminDashboard/>
    </Layout>
  );
};

export default SuperAdminDashboardPage;
